
import { defineComponent } from "vue";
import { useStore } from "vuex";
import CombatImplants from "./CombatImplants.vue";
import GenericPanel from "../shared/GenericPanel.vue";
import GenericSubPanel from "../shared/GenericSubPanel.vue";

export default defineComponent({
  name: "LevelPool",
  components: {
    CombatImplants,
    GenericPanel,
    GenericSubPanel
},
  setup() {
    const store = useStore();
    return {
      state: store.state,
    };
  },
});
